import { render, staticRenderFns } from "./ModalOneClick.vue?vue&type=template&id=35734258&"
import script from "./ModalOneClick.vue?vue&type=script&lang=js&"
export * from "./ModalOneClick.vue?vue&type=script&lang=js&"
import style0 from "./ModalOneClick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports